<template>
  <v-row no-gutters>
    <feature-card-basic ref="featureCard" :layer="layer" v-if="isFetched">
      <template #top v-if="masterplanRpVisible">
        <sidebar-row v-for="(attachment, idx) in computedAttachments" :key="idx" slot-cols="auto">
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-col style="max-width: 23vw; position: relative" class="text-left pb-0 px-0">
                <img :src="attachment" style="max-width: 100%" />
                <v-btn
                  v-if="hover"
                  style="position: absolute; top: 15px; right: 3px"
                  class="pa-0"
                  color="rgba(255,255,255,0.5)"
                  height="30"
                  width="30"
                  min-width="30"
                  depressed
                  @click="showFullScreenAttachment(idx)"
                >
                  <v-icon color="rgba(0,0,0,0.6)">mdi-fullscreen</v-icon>
                </v-btn>
              </v-col>
            </template>
          </v-hover>
        </sidebar-row>
      </template>
    </feature-card-basic>
    <main-loader v-else class="pt-10" />
    <image-lightbox :items="computedAttachments" :visible.sync="overlay"></image-lightbox>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';
import MainLoader from '@/components/MainLoader';
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'FeatureCardMasterplanRp',
  components: {
    FeatureCardBasic,
    MainLoader,
    SidebarRow,
    ImageLightbox: () => import('@/components/ImageLightbox'),
  },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isFetched: false,
    overlay: false,
    selectedAttachment: undefined,
  }),
  created() {
    this.init();
  },
  computed: {
    token: get('authentication/token'),
    isAdminEnabled: get('admin/settingsValues@masterplan_rp_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@MASTERPLAN_RP.enabled'),
    modulesPermissions: get('users/toolsPermissions'),
    attachmentsForFeature: get('relations/attachmentsForFeature'),
    currentLayerDataSourceName: get('layers/currentLayer@data_source_name'),
    masterplanRpDocumentsCategories: get('admin/modulesMapping@masterplan_rp.documents_categories'),
    currentFeatureId() {
      return this.$route?.params?.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    permissions() {
      const value = this.modulesPermissions['MASTERPLAN_RP'].main_value;
      return {
        edit: value > 1,
        preview: value > 0,
        value,
      };
    },
    masterplanRpVisible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permissions.preview;
    },
    computedAttachments() {
      return this.attachmentsForFeature
        .filter(attachment => this.masterplanRpDocumentsCategories.includes(attachment.properties?.category))
        .sort((a, b) => {
          return a.properties?.category
            ?.toString()
            .toLowerCase()
            .localeCompare(b.properties?.category?.toString().toLowerCase());
        })
        .map(attachment => this.getAttachmentsUrl(attachment.properties.id));
    },
  },
  methods: {
    getRelations: call('relations/getRelations'),
    async init() {
      this.isFetched = false;
      if (this.masterplanRpVisible) {
        if (this.currentLayerDataSourceName && (this.currentFeatureId || this.currentFeatureId === 0)) {
          const payload = {
            data_source_name: this.currentLayerDataSourceName,
            feature_id: this.currentFeatureId,
          };
          await this.getRelations(payload);
        }
      }
      this.isFetched = true;
    },
    getAttachmentsUrl(id) {
      return `${process.env.VUE_APP_API_URL}/attachments/${id}/file?token=${this.token}`;
    },
    showFullScreenAttachment(idx) {
      this.selectedAttachment = idx;
      this.overlay = true;
    },
  },
  watch: {
    currentFeatureId(nV) {
      if (nV || nV === 0) {
        this.init();
      }
    },
  },
};
</script>

<style lang="scss">
.carousel_image {
  .v-responsive__content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
